/**
 * Znajduje zmienną kluczową w topics po ID
 * @param {string|number} variableId - ID zmiennej
 * @param {Array} topics - Lista topics do przeszukania
 * @param {boolean} isCompareMode - Czy jesteśmy w trybie porównania
 * @returns {Object|null} - Obiekt zmiennej {id, name, ...} lub null
 */
export function findKeyVariableInTopics(variableId, topics, isCompareMode = false) {
   if (!topics || !variableId) return null;
   
   for (let t of topics) {
      let item = null;
      
      if (isCompareMode) {
         // W trybie porównania najpierw szukamy w common_key_variables
         const commonVars = t.common_key_variables || [];
         item = commonVars.find(kv => kv.edition1 === variableId || Number(kv.edition1) === Number(variableId));
         if (item) {
            return {
               id: item.edition1,
               name: item.name || "Zmienna",
               ...item
            };
         }
         // Jeśli nie ma common_key_variables, szukamy w keyVariables
         item = t.keyVariables?.find(k => k.id === variableId || Number(k.id) === Number(variableId));
         if (item) {
            return item;
         }
      } else {
         item = t.keyVariables?.find(k => k.id === variableId || Number(k.id) === Number(variableId));
         if (item) return item;
      }
      
      // Szukaj w children
      if (!!t.children?.length) {
         for (let c of t.children) {
            if (isCompareMode) {
               // Najpierw szukamy w common_key_variables
               const childCommonVars = c.common_key_variables || [];
               const childItem = childCommonVars.find(kv => kv.edition1 === variableId || Number(kv.edition1) === Number(variableId));
               if (childItem) {
                  return {
                     id: childItem.edition1,
                     name: childItem.name || "Zmienna",
                     ...childItem
                  };
               }
               // Jeśli nie ma common_key_variables, szukamy w keyVariables
               const childKeyItem = c.keyVariables?.find(k => k.id === variableId || Number(k.id) === Number(variableId));
               if (childKeyItem) {
                  return childKeyItem;
               }
            } else {
               const childItem = c.keyVariables?.find(k => k.id === variableId || Number(k.id) === Number(variableId));
               if (childItem) return childItem;
            }
         }
      }
   }
   
   return null;
}
